import React, { useState, useCallback, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
// import axios from "axios";
import { fetchDeliveryInfo } from "../store/action/deliveryActions";
import {
  FaMapMarkerAlt,
  FaShoppingBag,
  FaCreditCard,
  FaSearch,
  FaChevronDown,
  FaChevronUp,
  FaStore,
} from "react-icons/fa";
import { VscDebugBreakpointUnsupported } from "react-icons/vsc";
import { BiSupport } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../home/Loader";
import Infor from "./Infor";
import Cart from "./Cart";
import "./checkout.css";
import PageTitle from "../store/PageTitle";
import PostHog from "posthog-js";

const serverUrl = process.env.REACT_APP_SERVER_URL;
// API Service Module
const DeliveryService = {
  fetchZones: async () => {
    const response = await fetch(`${serverUrl}/delivery-zones`);
    if (!response.ok) throw new Error("Failed to fetch zones");
    return await response.json();
  },

  fetchStores: async () => {
    // Mock data for stores
    const mockStores = [
      { id: 1, name: "City Gamers Arcades Mall", address: "Arcades Mall" },
      { id: 2, name: "City Gamers Novela Mall", address: "Novela Mall" },
      { id: 3, name: "City Gamers Kwazi RD", address: "Kwazi RD" },
    ];

    return mockStores;
  },

  saveDeliveryInfo: async (payload) => {
    const response = await fetch(`${serverUrl}/users-delivery-infor`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error("Failed to save information");
    return await response.json();
  },

  savePickupInfo: async (payload) => {
    const response = await fetch(`${serverUrl}/users-delivery-infor`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error("Failed to save pickup info");
    return await response.json();
  },

  calculateDeliveryFee: async (coordinates) => {
    const response = await fetch(`${serverUrl}/calculate-fee`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(coordinates),
    });
    if (!response.ok) throw new Error("Failed to calculate fee");
    return await response.json();
  },
};

const ZoneDropdown = ({ zones, selectedZone, onSelect, isEditing }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  const filteredZones = zones.filter((zone) =>
    zone.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="zone-dropdown-container" ref={dropdownRef}>
      <PageTitle title="Checkout" />
      <div
        className="zone-dropdown-header"
        onClick={() => isEditing && setIsOpen(!isOpen)}
      >
        <div className="selected-zone">
          {selectedZone ? (
            <>
              <span className="zone-name">{selectedZone.name}</span>
              <span className="zone-fee">
                K{selectedZone.delivery_fee?.toFixed(2)}
              </span>
            </>
          ) : (
            <span className="placeholder">Select a delivery zone</span>
          )}
        </div>
        {isEditing && (
          <div className="dropdown-icon">
            {isOpen ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        )}
      </div>

      {isOpen && (
        <div className="dropdown-content">
          <div className="search-container-zone">
            <FaSearch className="search-zone" />
            <input
              type="text"
              placeholder="Search zones..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
          </div>

          <div className="zones-list">
            {filteredZones.map((zone) => (
              <div
                key={zone.id}
                className="zone-item"
                onClick={() => onSelect(zone)}
              >
                <span className="zone-name">{zone.name}</span>
                <span className="zone-fee">
                  K{zone.delivery_fee.toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const StoreDropdown = ({ stores, selectedStore, onSelect, isEditing }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  const filteredStores = stores.filter((store) =>
    store.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="zone-dropdown-container" ref={dropdownRef}>
      <div
        className="zone-dropdown-header"
        onClick={() => isEditing && setIsOpen(!isOpen)}
      >
        <div className="selected-zone">
          {selectedStore ? (
            <>
              <span className="zone-name">{selectedStore.name}</span>
              <span className="zone-fee">{selectedStore.address}</span>
            </>
          ) : (
            <span className="placeholder">Select a store for pickup</span>
          )}
        </div>
        {isEditing && (
          <div className="dropdown-icon">
            {isOpen ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        )}
      </div>

      {isOpen && (
        <div className="dropdown-content">
          <div className="search-container-zone">
            <FaSearch className="search-zone" />
            <input
              type="text"
              placeholder="Search stores..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
          </div>

          <div className="zones-list">
            {filteredStores.map((store) => (
              <div
                key={store.id}
                className="zone-item"
                onClick={() => onSelect(store)}
              >
                <span className="zone-name">{store.name}</span>
                <span className="zone-fee">{store.address}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const Checkout = ({ isCartOpen, closeCart, closeCartRef }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = useSelector((state) => state.auth.user?.id);
  const savedAddress = useSelector((state) => state.deli.deliveryInfo);
  const { checkoutItems, totalAmount } = useSelector((state) => state.checkout);

  const [formData, setFormData] = useState({
    street: "",
    fullName: "",
    contact: "",
    email: "",
  });

  const [state, setState] = useState({
    zones: [],
    stores: [],
    selectedZone: null,
    selectedStore: null,
    isEditing: false,
    isLoading: false,
    geoEnabled: false,
    location: null,
    deliveryInfo: null,
    error: null,
    deliveryMethod: savedAddress?.deliveryMethod || "delivery", //  set based on savedAddress
  });

  useEffect(() => {
    const loadData = async () => {
      try {
        setState((prev) => ({ ...prev, isLoading: true }));
        const zones = await DeliveryService.fetchZones();
        const stores = await DeliveryService.fetchStores();
        setState((prev) => ({ ...prev, zones, stores, isLoading: false }));
        if (userId) {
          dispatch(fetchDeliveryInfo(userId));
        }
      } catch (error) {
        setState((prev) => ({
          ...prev,
          error: error.message,
          isLoading: false,
        }));
      }
    };

    loadData();
  }, [userId, dispatch]);

  useEffect(() => {
    if (savedAddress) {
      setFormData({
        street: savedAddress.street || "",
        fullName: savedAddress.full_name || "",
        contact: savedAddress.contact || "",
        email: savedAddress.email || "",
      });

      setState((prev) => ({
        ...prev,
        deliveryMethod: savedAddress.deliveryMethod || "delivery", // Use deliveryMethod from savedAddress
        selectedZone:
          savedAddress.deliveryMethod === "delivery" && savedAddress.zone_name
            ? {
                name: savedAddress.zone_name,
                delivery_fee: savedAddress.fee,
              }
            : null,
        selectedStore:
          savedAddress.deliveryMethod === "pickup" && savedAddress.store_name
            ? {
                name: savedAddress.store_name,
                address: savedAddress.store_address,
              }
            : null,
      }));
    }
  }, [savedAddress]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleGeoLocationToggle = async (checked) => {
    try {
      setState((prev) => ({
        ...prev,
        geoEnabled: checked,
        isLoading: true,
        error: null,
      }));

      if (checked) {
        const position = await getGeolocation();
        const { latitude, longitude } = position.coords;
        const feeData = await DeliveryService.calculateDeliveryFee({
          latitude,
          longitude,
        });

        setState((prev) => ({
          ...prev,
          location: { latitude, longitude },
          deliveryInfo: feeData,
          selectedZone: {
            name: feeData.zoneName,
            delivery_fee: feeData.deliveryFee,
          },
        }));
      }
    } catch (error) {
      setState((prev) => ({
        ...prev,
        error: error.message,
        geoEnabled: false,
      }));
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  // const handleSaveDeliveryInfo = async () => {
  //   try {
  //     setState((prev) => ({ ...prev, isLoading: true }));

  //     const payload = {
  //       street: formData.street,
  //       full_name: formData.fullName,
  //       email: formData.email,
  //       contact: formData.contact,
  //       zone_name: state.selectedZone?.name,
  //       user_id: userId,
  //       fee: Number(state.selectedZone?.delivery_fee).toFixed(2),
  //     };

  //     await DeliveryService.saveDeliveryInfo(payload);
  //     setState((prev) => ({ ...prev, isEditing: false, isLoading: false }));
  //     toast.success("Delivery information saved successfully!");
  //   } catch (error) {
  //     setState((prev) => ({ ...prev, error: error.message, isLoading: false }));
  //     toast.error(`Failed to save: ${error.message}`);
  //   }
  // };

  // const handleSavePickupInfo = async () => {
  //   try {
  //     setState((prev) => ({ ...prev, isLoading: true }));

  //     const payload = {
  //       full_name: formData.fullName,
  //       email: formData.email,
  //       contact: formData.contact,
  //       store_id: state.selectedStore?.id,
  //       store_name: state.selectedStore?.name,
  //       user_id: userId,
  //     };

  //     await DeliveryService.savePickupInfo(payload);
  //     setState((prev) => ({ ...prev, isEditing: false, isLoading: false }));
  //     toast.success("Pickup information saved successfully!");
  //   } catch (error) {
  //     setState((prev) => ({ ...prev, error: error.message, isLoading: false }));
  //     toast.error(`Failed to save: ${error.message}`);
  //   }
  // };

  const handleSaveInfo = async () => {
    try {
      setState((prev) => ({ ...prev, isLoading: true }));

      const payload = {
        full_name: formData.fullName,
        email: formData.email,
        contact: formData.contact,
        user_id: userId,
        deliveryMethod: state.deliveryMethod, // Add delivery method to the payload
      };

      if (state.deliveryMethod === "delivery") {
        payload.street = formData.street;
        payload.zone_name = state.selectedZone?.name;
        payload.fee = Number(state.selectedZone?.delivery_fee).toFixed(2);
      } else if (state.deliveryMethod === "pickup") {
        payload.store_name = state.selectedStore?.name;
      }

      await DeliveryService.saveDeliveryInfo(payload);
      setState((prev) => ({ ...prev, isEditing: false, isLoading: false }));
      toast.success(
        `${
          state.deliveryMethod === "delivery" ? "Delivery" : "Pickup"
        } information saved successfully!`
      );
    } catch (error) {
      setState((prev) => ({ ...prev, error: error.message, isLoading: false }));
      toast.error(`Failed to save: ${error.message}`);
    }
  };

  // OPEN INFOR POPUP
  const [isInforOpen, setIsinforOpen] = useState(false);

  const toggleInfor = useCallback(() => {
    setIsinforOpen((prev) => !prev);
  }, []);

  const closeInfor = useCallback(() => {
    setIsinforOpen(false);
  }, []);

  // const getCityAndProvince = async (zone_name) => {
  //   try {
  //     const response = await axios.get(
  //       "https://nominatim.openstreetmap.org/search",
  //       {
  //         params: {
  //           q: zone_name,
  //           format: "json",
  //           addressdetails: 1,
  //           limit: 1,
  //         },
  //       }
  //     );

  //     if (response.data.length === 0) {
  //       return { error: "Location not found" };
  //     }

  //     const address = response.data[0].address;
  //     return {
  //       city:
  //         address.city ||
  //         address.town ||
  //         address.village ||
  //         address.hamlet ||
  //         "Unknown",
  //       province: address.state || "Unknown",
  //       country: address.country || "Unknown",
  //     };
  //   } catch (error) {
  //     console.error("Error fetching location:", error.message);
  //     return { error: "Failed to fetch location" };
  //   }
  // };

  const handleProceedToPayment = () => {
    if (state.deliveryMethod === "delivery" && !state.selectedZone) {
      toast.info("Please select a delivery zone first");
      return;
    }

    if (state.deliveryMethod === "pickup" && !state.selectedStore) {
      toast.info("Please select a store for pickup first");
      return;
    }
    PostHog.capture("Proceed to Payment", {
      property: "Total Amount",
      value: total,
    });
    const paymentDetails = {
      items: checkoutItems.map((item) => ({
        item_name: item.item_name,
        item_img: Array.isArray(item.itemPhotos)
          ? item.itemPhotos[0] || "/placeholder-image.jpg"
          : item.itemPhotos || "/placeholder-image.jpg",
        item_price: item.price,
        item_qty: item.quantity,
        item_condition: item.condition,
      })),
      user: {
        name: formData.fullName,
        contact: formData.contact,
        user_id: userId,
        email: formData.email,
      },
      deliveryMethod: state.deliveryMethod,
      delivery:
        state.deliveryMethod === "delivery"
          ? {
              zone: state.selectedZone?.name,
              street: formData.street,
              fee: deliveryFee,
            }
          : {
              store: state.selectedStore?.name,
              fee: 0,
            },
      payment: {
        total: total,
        subtotal: totalAmount,
      },
    };

    navigate("/payment", { state: { paymentDetails } });
  };

  const deliveryFee =
    state.deliveryMethod === "delivery"
      ? Number(state.selectedZone?.delivery_fee || 0)
      : 0;

  const toggleDeliveryMethod = (method) => {
    setState((prev) => ({ ...prev, deliveryMethod: method }));
  };

  const calculateTransactionFee = (amount) => {
    const feePercentage = 0.01; // 1% transaction fee
    return amount * feePercentage;
  };

  const total =
    (totalAmount || 0) + deliveryFee + calculateTransactionFee(totalAmount);

  return (
    <div className="checkout-container">
      {isCartOpen && <Cart closeCart={closeCart} closeCartRef={closeCartRef} />}
      <h2>Check out</h2>
      <div className="checkout-grid">
        {/* Delivery Information Card */}
        <div className="card">
          <div className="card-header">
            <div className="flex-title">
              <h3 className="card-title-deli">
                {state.deliveryMethod === "delivery" ? (
                  <FaMapMarkerAlt className="icon" />
                ) : (
                  <FaStore className="icon" />
                )}{" "}
                {state.deliveryMethod === "delivery"
                  ? "Delivery Information"
                  : "Self-Pickup Information"}
              </h3>
              <span>
                <VscDebugBreakpointUnsupported
                  onClick={toggleInfor}
                  size={30}
                  className="icon support"
                />
                <Link to="/Contact">
                  <BiSupport size={25} className="icon support" />
                </Link>
              </span>
            </div>
            {isInforOpen && <Infor closeInfor={closeInfor} />}
          </div>

          <div className="card-content">
            {/* Delivery Method Switcher */}
            <div className="delivery-method-switcher">
              <div
                className={`method-option ${
                  state.deliveryMethod === "delivery" ? "active" : ""
                }`}
                onClick={() => toggleDeliveryMethod("delivery")}
              >
                <FaMapMarkerAlt className="method-icon" />
                <span>Delivery</span>
              </div>
              <div
                className={`method-option ${
                  state.deliveryMethod === "pickup" ? "active" : ""
                }`}
                onClick={() => toggleDeliveryMethod("pickup")}
              >
                <FaStore className="method-icon" />
                <span>Self-Pickup</span>
              </div>
            </div>

            {state.deliveryMethod === "delivery" ? (
              // Delivery Information Form
              <>
                <ZoneDropdown
                  zones={state.zones}
                  selectedZone={state.selectedZone}
                  onSelect={(zone) =>
                    setState((prev) => ({ ...prev, selectedZone: zone }))
                  }
                  isEditing={state.isEditing}
                />

                <div className="toggle-row">
                  {state.isLoading ? (
                    <div className="loading">
                      <Loader />
                    </div>
                  ) : (
                    <span>Can't see Zone? Toggle to auto-select</span>
                  )}
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={state.geoEnabled}
                      onChange={(e) =>
                        handleGeoLocationToggle(e.target.checked)
                      }
                      disabled={state.isLoading || !state.isEditing}
                    />
                    <span className="slider"></span>
                  </label>
                </div>

                <div className="input-group">
                  <input
                    type="text"
                    className="input"
                    placeholder="Street address"
                    name="street"
                    value={formData.street}
                    onChange={handleInputChange}
                    disabled={!state.isEditing}
                    required
                  />
                </div>
              </>
            ) : (
              // Self-Pickup Information Form
              <StoreDropdown
                stores={state.stores}
                selectedStore={state.selectedStore}
                onSelect={(store) =>
                  setState((prev) => ({ ...prev, selectedStore: store }))
                }
                isEditing={state.isEditing}
              />
            )}

            {/* Common fields for both methods */}
            <div className="input-row">
              <input
                type="text"
                className="input"
                placeholder="Full Name"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                disabled={!state.isEditing}
                required
              />
              <input
                type="tel"
                className="input"
                placeholder="Contact Number"
                name="contact"
                value={formData.contact}
                disabled={!state.isEditing}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="email"
                className="input"
                placeholder="Email address"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                disabled={!state.isEditing}
                required
              />
            </div>

            <button
              className="proceed-button"
              onClick={
                state.isEditing
                  ? handleSaveInfo
                  : () => setState((prev) => ({ ...prev, isEditing: true }))
              }
            >
              {state.deliveryMethod === "delivery" ? (
                <FaMapMarkerAlt className="icon" />
              ) : (
                <FaStore className="icon" />
              )}
              {state.isEditing
                ? state.deliveryMethod === "delivery"
                  ? "Save Delivery Information"
                  : "Save Pickup Information"
                : state.deliveryMethod === "delivery"
                ? "Edit Delivery Information"
                : "Edit Pickup Information"}
            </button>
          </div>
        </div>

        {/* Cart Summary Card */}
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">
              <FaShoppingBag className="icon" /> Cart Summary
            </h3>
          </div>

          <div className="card-content">
            <div className="cart-items">
              {checkoutItems.map((item) => (
                <div key={item.id} className="cart-item">
                  <div className="item-image">
                    <img
                      src={
                        Array.isArray(item.itemPhotos)
                          ? item.itemPhotos[0] || "/placeholder-image.jpg"
                          : item.itemPhotos || "/placeholder-image.jpg"
                      }
                      alt={item.item_name || "Unnamed Item"}
                      className="product-image"
                    />
                  </div>
                  <div className="item-info">
                    <p className="item-name">{item.item_name}</p>
                    <p className="item-quantity">Quantity: {item.quantity}</p>
                  </div>
                  <p className="item-price">K {item.price?.toLocaleString()}</p>
                </div>
              ))}
            </div>

            <div className="summary">
              <div className="summary-row">
                <span>Sub-Total</span>
                <span>
                  K {totalAmount?.toFixed(2).toLocaleString() || "0.00"}
                </span>
              </div>
              <div className="summary-row">
                <span>Transaction Fee</span>
                <span>
                  K{" "}
                  {calculateTransactionFee(totalAmount)
                    ?.toFixed(2)
                    .toLocaleString() || "0.00"}
                </span>
              </div>
              <div className="summary-row">
                <span>
                  {state.deliveryMethod === "delivery"
                    ? "Delivery Fee"
                    : "Pickup Fee"}
                </span>
                <span>K {deliveryFee.toFixed(2).toLocaleString()}</span>
              </div>
              <div className="summary-row total">
                <span>Total</span>
                <span>K {total.toFixed(2).toLocaleString()}</span>
              </div>
            </div>

            <button className="proceed-button" onClick={handleProceedToPayment}>
              <FaCreditCard className="icon" /> Proceed to Payment
            </button>
            <ToastContainer position="top-center" />
          </div>
        </div>
      </div>
    </div>
  );
};

const getGeolocation = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      resolve,
      (error) => {
        const errors = {
          1: "Please enable location permissions",
          2: "Location unavailable",
          3: "Location request timed out",
        };
        reject(new Error(errors[error.code] || "Failed to get location"));
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  });

export default Checkout;
